<script>
import MultipleChecks from '@wielink-application/shared/vue/components/form/horizontal/multiple-checks.vue'

export default MultipleChecks;
</script>